import React from 'react';
import { useTranslate, required, TextInput } from 'react-admin';
import { HiddenInput } from '~/components/ra';
import { SelectInput } from 'react-admin';

interface ApplicationRuleFormProps {
  edit?: boolean;
}

const ApplicationRuleForm = (props: ApplicationRuleFormProps) => {
  const { edit } = props;
  const translate = useTranslate();
  const t = (key: string): string => translate(`resources.applicationRules.fields.${key}`);
  return (
    <>
      {edit && <HiddenInput source='id' />}
      <TextInput
        source='applicationId'
        label={t('applicationId')}
        fullWidth
        validate={required()}
      />
      <SelectInput
        source='platform'
        label={t('platform')}
        choices={[
          { id: 'ANDROID', name: t('ANDROID') },
          { id: 'IOS', name: t('IOS') },
        ]}
        fullWidth
        validate={required()}
      />
      <TextInput
        source='minRequiredVersion'
        label={t('minRequiredVersion')}
        fullWidth
        validate={required()}
      />
      <TextInput source='recommendedVersion' label={t('recommendedVersion')} fullWidth />
      <TextInput source='link' label={t('link')} fullWidth validate={required()} />
    </>
  );
};

export default ApplicationRuleForm;
